import React, { ReactNode } from 'react';
import { Provider, ProviderEntity } from '../../../../../../../models/provider';
import { H1 } from '../../../../../../atoms/Heading/Heading';
import { StyledLogo } from '../../../../../DeviceHandoff/DeviceHandoff.styles';
import { ImageWrapper, StyledImage, StyledUserHintId } from './InstructionList.styles';

export type InstructionListProps = {
  provider: ProviderEntity;
  providerAppIcon?: string;
  title: ReactNode;
  userHintId?: string;
};

export const InstructionListHeader: React.FC<InstructionListProps> = ({
  provider,
  providerAppIcon,
  title,
  userHintId,
}) => {
  return (
    <>
      <ImageWrapper>
        {providerAppIcon ? (
          <StyledLogo src={providerAppIcon} padding={false} />
        ) : (
          <StyledImage src={Provider.getIcon(provider)} alt="" />
        )}
      </ImageWrapper>

      <H1 mt="none" align="center">
        {title}
      </H1>

      {userHintId && <StyledUserHintId>{userHintId}</StyledUserHintId>}
    </>
  );
};
